export default __webpack_public_path__ + "static/media/video-cam-small.e2c724ad.svg";